export const createStyles = (theme?: any, staffAlertOffset = 0) => {
  const isDark = theme?.palette?.mode === 'dark';
  const darkBorder = '#2E2A36';
  const lightBorder = '#ECE8F3';
  const darkPageBg = '#3A3444';
  const lightPageBg = '#FFFFFF';

  return {
    // Desktop: full-height flex row (sidebar + content) — matches AssignmentResponsive
    desktopShell: {
      height: { md: `calc(100dvh - 64px - ${staffAlertOffset}px)` },
      display: 'flex',
      alignItems: 'start',
      justifyContent: 'start',
      minHeight: 0,
      overflow: 'hidden',
      fontFamily: theme?.typography?.fontFamily,
    },
    leftWrapper: {
      height: '100%',
      maxHeight: '100%',
      width: { md: '360px' },
      flexShrink: 0,
      backgroundColor: isDark ? darkPageBg : lightPageBg,
      borderTop: `1px solid ${isDark ? darkBorder : lightBorder}`,
      borderRight: `1px solid ${isDark ? darkBorder : lightBorder}`,
      borderBottom: 0,
      borderLeft: 0,
    },
    contentArea: {
      flex: '1',
      minWidth: 0,
      padding: '40px 1.5rem 1rem',
      overflowY: 'auto',
      height: '100%',
      boxSizing: 'border-box',
    },
    // Mobile: full-height single column — matches AssignmentResponsive pageWrapper
    mobilePage: {
      height: '100dvh',
      px: '16px',
      pt: '16px',
      pb: '12px',
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      fontFamily: theme?.typography?.fontFamily,
    },
    // Back button row — matches AssignmentResponsive buttonWrapper
    backButtonWrapper: {
      marginLeft: '-8px',
      flexShrink: 0,
    },
    // White card container for mobile detail content — matches AssignmentResponsive pageContent
    mobileContentWrapper: {
      flex: 1,
      minHeight: 0,
      overflowY: 'auto',
      px: '16px',
      py: '24px',
      backgroundColor: isDark ? darkPageBg : lightPageBg,
      borderRadius: '8px',
    },
  };
};
